module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_maedori@2x-ac18ae860c4f1f821943bd3fe0241414.webp";